document.addEventListener('DOMContentLoaded', function() {
    const sizechartButton = document.getElementById('sizechart-button');
    
    if (sizechartButton) {
        sizechartButton.addEventListener('click', function() {
            showSizeChart();
        });
    }
    
    function showSizeChart() {
        // Get all variant data from the form
        const variantInputs = document.querySelectorAll('input[name="id"][type="radio"]');
        const hiddenVariantInput = document.querySelector('input[name="id"][type="hidden"]');
        
        let variants = [];
        
        // Collect variant data from radio inputs or hidden input
        if (variantInputs.length > 0) {
            variantInputs.forEach(input => {
                const variantId = input.value;
                const variantTitle = input.nextElementSibling.textContent.trim();
                variants.push({
                    id: variantId,
                    title: variantTitle,
                    disabled: input.disabled
                });
            });
        } else if (hiddenVariantInput) {
            // Single variant product
            variants.push({
                id: hiddenVariantInput.value,
                title: 'Jeden rozmiar',
                disabled: false
            });
        }
        
        // Create modal overlay
        const modalOverlay = document.createElement('div');
        modalOverlay.className = 'fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-2 sm:p-4';
        modalOverlay.id = 'sizechart-modal';
        
        // Create modal content
        const modalContent = document.createElement('div');
        modalContent.className = 'bg-white max-w-4xl w-full max-h-[90vh] overflow-y-auto rounded-lg p-3 sm:p-6';
        
        // Create modal header
        const modalHeader = document.createElement('div');
        modalHeader.className = 'flex justify-between items-center mb-4 sm:mb-6 border-b border-gray-200 pb-3 sm:pb-4';
        modalHeader.innerHTML = `
            <h2 class="text-lg sm:text-2xl font-light">Tabela rozmiarów</h2>
            <button id="close-sizechart" class="text-gray-500 hover:text-gray-700 text-2xl cursor-pointer">×</button>
        `;
        
        // Create size chart content
        const sizeChartContent = document.createElement('div');
        sizeChartContent.className = 'space-y-4 sm:space-y-6';
        
        // Generate size chart for each available variant
        const availableVariants = variants.filter(variant => !variant.disabled);
        
        if (availableVariants.length > 0) {
            availableVariants.forEach((variant, index) => {
                const variantSection = document.createElement('div');
                variantSection.className = 'border border-gray-200 rounded-lg p-3 sm:p-4';
                
                const variantTitle = document.createElement('h3');
                variantTitle.className = 'text-base sm:text-lg font-medium mb-3 sm:mb-4';
                variantTitle.textContent = variant.title;
                
                const table = createSizeTable(variant.id);
                
                variantSection.appendChild(variantTitle);
                variantSection.appendChild(table);
                sizeChartContent.appendChild(variantSection);
            });
        } else {
            sizeChartContent.innerHTML = '<p class="text-center text-gray-500">Brak dostępnych rozmiarów</p>';
        }
        
        // Add size chart info
        const sizeInfo = document.createElement('div');
        sizeInfo.className = 'mt-4 sm:mt-6 p-3 sm:p-4 bg-gray-50 rounded-lg text-xs sm:text-sm text-gray-600';
        sizeInfo.innerHTML = '<p><strong>Informacja:</strong> Wszystkie wymiary podane są w centymetrach.</p> <br /> <p><strong>Uwaga:</strong> Wymiary mogą się róźnić o ±2 cm</p>';

        
        // Assemble modal
        modalContent.appendChild(modalHeader);
        modalContent.appendChild(sizeChartContent);
        modalContent.appendChild(sizeInfo);
        modalOverlay.appendChild(modalContent);
        
        // Add to page
        document.body.appendChild(modalOverlay);
        
        // Add event listeners
        const closeButton = document.getElementById('close-sizechart');
        closeButton.addEventListener('click', closeSizeChart);
        
        modalOverlay.addEventListener('click', function(e) {
            if (e.target === modalOverlay) {
                closeSizeChart();
            }
        });
        
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
    }
    
    function createSizeTable(variantId) {
        // Get metafields for this variant from the global product object
        const metafields = window.productMetafields && window.productMetafields[variantId];
        
        if (!metafields) {
            const noData = document.createElement('p');
            noData.className = 'text-gray-500 text-center py-4';
            noData.textContent = 'Brak danych o rozmiarach dla tego wariantu';
            return noData;
        }
        
        // Check what type of measurements we have
        const hasTopMeasurements = metafields.szerokosc && metafields.dlugosc &&  metafields.ramionko;
        const hasBottomMeasurements = metafields.calkowita_dlugosc_sciagacza && metafields.po_zagieciu_sciagacza && metafields.nogawka && metafields.obwod;
        const hasTopMeasurements2 = metafields.rekaw && metafields.dlugosc2 && metafields.obwod_w_biuscie;
        const hasBottomMeasurements2 = metafields.obwod_w_pasie && metafields.dlugosc &&  metafields.obwod_w_biodrach;
        
        // Create table container with horizontal scroll
        const tableContainer = document.createElement('div');
        tableContainer.className = 'w-full overflow-x-auto';
        
        const table = document.createElement('table');
        table.className = 'w-full border-collapse border border-gray-300 min-w-full';
        
        const thead = document.createElement('thead');
        const tbody = document.createElement('tbody');
        
        let headers = [];
        let values = [];
        
        if (hasTopMeasurements) {
            // Top measurements (3 dimensions)
            if (metafields.dlugosc) {
                headers.push('Długość');
                values.push(metafields.dlugosc);
            }
            if (metafields.szerokosc) {
                headers.push('Szerokość');
                values.push(metafields.szerokosc);
            }
            if (metafields.ramionko) {
                headers.push('Ramionko');
                values.push(metafields.ramionko);
            }
        } else if (hasBottomMeasurements) {
            // Bottom measurements (4 dimensions) - use shorter labels for mobile
            if (metafields.calkowita_dlugosc_sciagacza) {
                headers.push('Całk. dł. ściągacza');
                values.push(metafields.calkowita_dlugosc_sciagacza);
            }
            if (metafields.po_zagieciu_sciagacza) {
                headers.push('Po zagięciu');
                values.push(metafields.po_zagieciu_sciagacza);
            }
            if (metafields.nogawka) {
                headers.push('Nogawka');
                values.push(metafields.nogawka);
            }
            if (metafields.obwod) {
                headers.push('Obwód');
                values.push(metafields.obwod);
            }
        } else if (hasBottomMeasurements2) {
            // Bottom measurements (3 dimensions) - use shorter labels for mobile
            if (metafields.dlugosc) {
                headers.push('Długość');
                values.push(metafields.dlugosc);
            }
            if (metafields.obwod_w_pasie) {
                headers.push('Obwód w pasie');
                values.push(metafields.obwod_w_pasie);
            }
            if (metafields.obwod_w_biodrach) {
                headers.push('Obwód w biodrach');
                values.push(metafields.obwod_w_biodrach);
            }
        } else if (hasTopMeasurements2) {
            // Bottom measurements (3 dimensions) - use shorter labels for mobile
            if (metafields.dlugosc2) {
                headers.push('Długość');
                values.push(metafields.dlugosc2);
            }
            if (metafields.obwod_w_biuscie) {
                headers.push('Obwód w biuście');
                values.push(metafields.obwod_w_biuscie);
            }
            if (metafields.rekaw) {
                headers.push('Rękaw');
                values.push(metafields.rekaw);
            }
        }
        
        if (headers.length === 0) {
            const noData = document.createElement('p');
            noData.className = 'text-gray-500 text-center py-4';
            noData.textContent = 'Brak danych o wymiarach dla tego wariantu';
            return noData;
        }
        
        // Create header row
        const headerRow = document.createElement('tr');
        headerRow.className = 'bg-gray-100';
        headers.forEach(header => {
            const th = document.createElement('th');
            th.className = 'border border-gray-300 px-2 sm:px-4 py-2 text-left font-medium text-xs sm:text-sm whitespace-nowrap';
            th.textContent = header;
            headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        
        // Create value row
        const valueRow = document.createElement('tr');
        values.forEach(value => {
            const td = document.createElement('td');
            td.className = 'border border-gray-300 px-2 sm:px-4 py-2 text-xs sm:text-sm whitespace-nowrap';
            td.textContent = value + ' cm';
            valueRow.appendChild(td);
        });
        tbody.appendChild(valueRow);
        
        table.appendChild(thead);
        table.appendChild(tbody);
        
        // Add table to container
        tableContainer.appendChild(table);
        
        return tableContainer;
    }
    
    function closeSizeChart() {
        const modal = document.getElementById('sizechart-modal');
        if (modal) {
            modal.remove();
            document.body.style.overflow = '';
        }
    }
    
    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeSizeChart();
        }
    });
});
